<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="center center">
  <ng-container [ngSwitch]="mimeType">
    <ng-container *ngSwitchCase="mimeTypes.PDF">
      <mat-icon  class="mr-8">picture_as_pdf</mat-icon>{{'REPORT-PANEL.FILES-REPORT' | translate:{mime: mimeTypesNames.PDF} }}
    </ng-container>
    <ng-container *ngSwitchCase="mimeTypes.ZIP">
      <mat-icon class="mr-8">folder_zip</mat-icon>{{'REPORT-PANEL.FILES-REPORT' | translate:{mime: mimeTypesNames.ZIP} }}
    </ng-container>
    <ng-container *ngSwitchDefault>
      <mat-icon class="mr-8">description</mat-icon>{{'REPORT-PANEL.OTHER-FILES' | translate}}
    </ng-container>
  </ng-container>
</h1>

<div mat-dialog-content>
  <div fxLayout="row wrap" fxLayoutAlign="flex-start center">

    <div *ngFor="let file of files" fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center"
      class="mat-elevation-z3 mb-12 p-8 card-file" (click)="downloadReportFile(file.id)">
      <button mat-icon-button color="accent" aria-label="Download report" class="mr-8" 
          matTooltip="{{'REPORT-PANEL.DOWNLOAD' | translate}} {{file.name}}">
          <mat-icon>file_download</mat-icon>
      </button>
      <mat-divider vertical="true" class="mr-8 h-44"></mat-divider>
      <span class="file-name">{{file.name}}</span>
    </div>

  </div>
</div>

<div mat-dialog-actions align="end">
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        [matDialogClose]="true">
        {{'BUTTONS.CLOSE' | translate}}
    </button>
</div>
